import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Route, Switch, Redirect } from 'react-router-dom'
import NProgress from 'nprogress'
import GoogleAnalytics from 'react-ga';

import PlayButton from '../PlayButton';
import StationButton from '../StationButton';
import ElementShortcuts from '../ElementShortcuts';
import TagList from '../TagList';
import Selector from '../Selector';
import ArtistOverview from './ArtistOverview';
import ArtistSimilarities from './ArtistSimilarities';

import Notification from '../../services/Notification.js'
import Train from '../../services/train.js';
import User from '../../services/User.js';
import NumberUtils from '../../services/NumberUtils.js';
import StringUtils from '../../services/StringUtils.js';

import '../../../css/Artist.css';
import '../../../css/elementPage.css';

class Artist extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      userData: {}
    }
  }

  fetchData(artistName) {

    NProgress.start();

    Train.fetchArtist({artist: artistName})
    .then((artist) => {
      this.setState({artist, artistName});
      NProgress.done();
    }).catch((e) => {
      NProgress.done();
      Notification.show('Error loading artist data', 'error');
    });

    let userId = User.getId();

    if (userId) {
      Train.fetchUserArtist({user: userId, artist: artistName})
      .then((userData) => {
        this.setState({userData});
      })
      .catch((error) => {
        this.setState({userData: {}});
      });
    }

    

  }

  componentDidMount() {
    let artist = decodeURIComponent(this.props.match.params.artist);
    this.fetchData(artist);
  }

  componentWillReceiveProps(newProps) {
    let artist = decodeURIComponent(newProps.match.params.artist);
    if (artist !== this.state.artistName) {
      this.setState({artist: undefined, artistName: undefined});
      this.fetchData(artist);    
    }
  }

  discover() {

    let loggedIn = User.isLoggedIn();

    if (loggedIn) {

      let userData = this.state.userData;

      let artist = this.state.artistName;

      let action = userData.discovered ? 'Undiscovered' : 'Discovered';

      GoogleAnalytics.event({
        category: 'Artist',
        action: action,
        label: artist
      });

      Train.discoverArtist({artist: this.state.artistName, status: !userData.discovered})
      .then(() => {
        Notification.show(`${action} ${artist}`, 'success');
        userData.discovered = !userData.discovered
        this.setState({userData});
      });
    }
    
  }

  summary() {
    let summary = this.state.artist.summary;
    summary = StringUtils.replaceAll(summary, '<a ', '<a class="clickable" target="_blank"');
    return summary;
  }

  render() {

    let artist = this.state.artist;
    let userData = this.state.userData;

    if (!artist) {
      return null;
    }

    let imageStyle = {
      backgroundImage: `url(${artist.img})`
    };

    let basePath = `/artists/${artist.artist}`;

    let selectorElements = [
      {title: 'Overview', url: `${basePath}/overview`}, 
      {title: 'Similar artists', url: `${basePath}/similar`}
    ];

    let country = artist.profile.location.country;
    let year = artist.profile.start_year;
    let gender = artist.profile.gender;

  
    return (
 

      <div className="elementPage">

        <div className="header">

          <div className="profileImage" style={imageStyle}>

            <i onClick={this.discover.bind(this)} className={`discovered fontastic icon-new clickable ${userData.discovered ? 'active' : ''}`}></i>
            { artist.tour && <a className="tour clickable" target="_blank" href={artist.tour.uri}>TOUR</a> }
          </div>

          <div className="content">

            <h1>{artist.artist}</h1>

            <div className="playArea">
              <PlayButton type={'artist'} element={artist}/>
              <StationButton type={'artist-station'} element={artist}/>
            </div>

            <br/>

            <div className="stats">
              {country && <span><b>Country</b> {StringUtils.titleize(country)}</span>}
              {year && <span><b>Year</b> {year}</span>}
              {gender && <span><b>Vocal</b> {StringUtils.titleize(gender)}</span>}
              <span><b>Listeners</b> {NumberUtils.abbreviation(artist.profile.stats.listeners)}</span>
              <span><b>Plays</b> {NumberUtils.abbreviation(artist.profile.stats.playcount)}</span>
              {userData.playcount !== undefined && <span><b>Your plays</b> {NumberUtils.abbreviation(userData.playcount)}</span>}
            </div>

            <TagList tags={artist.profile.tags} selector={true}/>

            <ElementShortcuts type={'artist'} element={artist} userData={userData}/>

          </div>

        </div>

        <div className="summary">
         { ReactHtmlParser(this.summary()) }
        </div>

        <Selector elements={selectorElements}></Selector>

        <Switch>
          <Route path="/artists/:artist/overview" component={ () => <ArtistOverview artist={artist}/> }></Route>
          <Route path="/artists/:artist/similar" component={ () => <ArtistSimilarities artist={artist}/> }></Route>
          <Route render={ () => <Redirect to={`${basePath}/overview`}/> }></Route>
        </Switch>

        
      </div>
              
    ); 

  }
}

export default Artist;



// WEBPACK FOOTER //
// ./src/js/components/artist/Artist.jsx